/** @format */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { GridRepeater } from '@toucan/client/shared/components/grid-repeater';

import { SearchFilter } from '@toucan/client/features/search/components/search-filter';
import { FilterOption } from '@toucan/client/features/search/config/types';

import { styles } from './filter-group.styles';
import { SearchFilterGroupProps } from './types';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'search-filter-group';

export const StyledSearchFilterGroup = styled.div`
    ${styles}
`;

export const SearchFilterGroup: FunctionComponent<SearchFilterGroupProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    filters,
    onUpdate,
    onFilterOpen,
    ...otherProps
}: SearchFilterGroupProps) => {
    function handleUpdate(
        index: number,
        filterOptions: FilterOption[],
        variant?: string
    ) {
        if (!onUpdate) {
            return;
        }
        const updatedFilters = [...filters];
        updatedFilters[index].selectedOptions = filterOptions;
        updatedFilters[index].selectedVariant = variant;
        onUpdate(updatedFilters);
    }

    return (
        <StyledSearchFilterGroup data-testid={dataTestId} {...otherProps}>
            <GridRepeater
                gridColumns={5}
                gridGap="0.8rem"
                data-testid={`${dataTestId}__grid-repeater`}
            >
                {filters.map((filter, index) => (
                    <SearchFilter
                        key={filter.id}
                        onUpdate={(filterOptions, variant) =>
                            handleUpdate(index, filterOptions, variant)
                        }
                        onOpen={onFilterOpen}
                        data-testid={`${dataTestId}__search-filter`}
                        className="search-filter"
                        filter={filter}
                        id={filter.id}
                        initialSelectedItems={filter.selectedOptions}
                    />
                ))}
            </GridRepeater>
        </StyledSearchFilterGroup>
    );
};
